import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { showToast } from "../../../utils/ToastHelper";
import { BASE_URL } from "../../Const/Url";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import swal from "sweetalert";
import Loader from "../../CustomCommons/Loader";
import { logout_func3 } from "../../Const/logoutCommon";

const NavCatalogExport = () => {
  const [selectedSlug, setSelectedSlug] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [navItems, setNavItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNavItems, setIsLoadingNavItems] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const exportBaseUrl = `${BASE_URL}api/v1/inventory/admin/catalog-product-export/`;
  const exportUrl = selectedSlug
    ? `${exportBaseUrl}?navbar_slug=${selectedSlug}`
    : exportBaseUrl;

  useEffect(() => {
    fetchNavItems("");
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchNavItems(searchTerm);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const container = document.querySelector(".nav-catalog-dropdown-container");
      if (container && !container.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  const fetchNavItems = (search = "") => {
    setIsLoadingNavItems(true);
    const params = new URLSearchParams({ limit: 100 });
    if (search) params.append("search", search);
    axios
      .get(`${BASE_URL}api/v1/frontend/admin/v2/navbar/?${params.toString()}`)
      .then((res) => {
        const results = res?.data?.data?.results || [];
        setNavItems(results);
      })
      .catch(() => showToast("error", "Failed to load nav items"))
      .finally(() => setIsLoadingNavItems(false));
  };

  const handleExport = () => {
    if (!selectedSlug) {
      showToast("error", "Please select a nav item");
      return;
    }
    setIsLoading(true);
    axios
      .get(exportUrl, { responseType: "blob" })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `nav-catalog-${selectedSlug}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        showToast("success", "Catalog exported successfully!");
      })
      .catch((err) => {
        try {
          const errorMsg = JSON.parse(err.request.response).errors;
          const message = JSON.parse(err.request.response).message;
          let errors = "Please, Try again, after Solving this errors: \n \n ";
          for (let key in errorMsg) {
            errors += errorMsg[key] + "\n\n";
          }
          swal({ icon: "error", text: errors });
          if (message === "Invalid token." || JSON.parse(err?.request?.response)?.code === 401) {
            logout_func3(history);
          }
        } catch {
          showToast("error", "Export failed. Please try again.");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(exportUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (isLoading) return <Loader />;

  return (
    <div
      className="categorey-parent pd-right"
      style={{ height: "100vh", background: "#FAFAFA" }}
    >
      <div className="bg-white mb-3">
        <div style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}>
          <h3 className="head-tag" style={{ marginBottom: "20px" }}>
            Nav Catalog Export Instructions
          </h3>
          <div className="inst mb-4" style={{ color: "#828282" }}>
            <p className="my-2">1. Use the search box to find the nav item you want to export.</p>
            <p className="my-2">2. Click on a nav item to select it.</p>
            <p className="my-2">3. Click the Export button to download the catalog as a CSV file.</p>
            <p className="my-2">4. The exported file will contain all product details for the selected nav item.</p>
            <p className="my-2">5. You can also copy the export URL using the Copy Export URL button.</p>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="side-pd" style={{ border: "0.5px solid #E0E0E0" }}>
          <h3 className="h5-head" style={{ marginTop: "6px", marginLeft: "12px" }}>
            Export Nav Catalog
          </h3>
        </div>

        <div className="side-pd bord">
          <RequiredLabel text={"Nav Item"} />
          <div className="row">
            <div className="col-11 col-lg-6 col-md-8">
              {isLoadingNavItems ? (
                <div className="d-flex align-items-center" style={{ height: "55px" }}>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span>Loading nav items...</span>
                </div>
              ) : (
                <>
                  <div className="position-relative nav-catalog-dropdown-container">
                    <div className="d-flex align-items-center border rounded" style={{ border: "1px solid #E0E0E0" }}>
                      <input
                        type="text"
                        className="form-control border-0"
                        placeholder={selectedTitle || "Search nav items..."}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onFocus={() => setIsDropdownOpen(true)}
                        style={{ height: "55px", borderRadius: "7px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-link border-0"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        style={{ minWidth: "40px" }}
                      >
                        <i className={`fas fa-chevron-${isDropdownOpen ? "up" : "down"}`}></i>
                      </button>
                    </div>

                    {isDropdownOpen && (
                      <div
                        className="border rounded position-absolute w-100 bg-white"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #E0E0E0",
                          zIndex: 1000,
                          top: "100%",
                          left: 0,
                          right: 0,
                        }}
                      >
                        {navItems.length === 0 ? (
                          <div className="p-3 text-center text-muted">
                            {searchTerm ? "No nav items found." : "No nav items available."}
                          </div>
                        ) : (
                          navItems.map((item) => (
                            <div
                              key={item.slug}
                              className="p-3 border-bottom"
                              style={{
                                cursor: "pointer",
                                transition: "background-color 0.2s",
                                backgroundColor:
                                  selectedSlug === item.slug ? "#e9ecef" : "transparent",
                              }}
                              onClick={() => {
                                setSelectedSlug(item.slug);
                                setSelectedTitle(item.title);
                                setIsDropdownOpen(false);
                                setSearchTerm("");
                                setHasSelected(true);
                              }}
                              onMouseEnter={(e) => {
                                if (selectedSlug !== item.slug)
                                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                              }}
                              onMouseLeave={(e) => {
                                if (selectedSlug !== item.slug)
                                  e.currentTarget.style.backgroundColor = "transparent";
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <div className="fw-bold">{item.title}</div>
                                  <small className="text-muted">
                                    {item.products_count} products • {item.categories_count} categories
                                  </small>
                                </div>
                                <span
                                  className={`badge ${item.is_active ? "bg-success" : "bg-secondary"}`}
                                >
                                  {item.is_active ? "Active" : "Inactive"}
                                </span>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  {hasSelected && (
                    <div className="mt-2">
                      <small className="text-muted">Selected: {selectedTitle}</small>
                    </div>
                  )}

                  {hasSelected && (
                    <div className="mt-3 position-relative d-inline-block">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleCopyUrl}
                        style={{ fontSize: "13px" }}
                      >
                        <i className="fas fa-copy me-1"></i> Copy Export URL
                      </button>
                      {copied && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "calc(100% + 8px)",
                            left: "50%",
                            transform: "translateX(-50%)",
                            background: "#333",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            pointerEvents: "none",
                            zIndex: 9999,
                          }}
                        >
                          Link Copied!
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: "50%",
                              transform: "translateX(-50%)",
                              border: "5px solid transparent",
                              borderTopColor: "#333",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="side-pd bord">
          <button
            onClick={handleExport}
            className="save-btn me-2 mt-2"
            style={{ background: "#000", color: "white" }}
          >
            Export Catalog
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavCatalogExport;
